import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthResponse } from '@model/auth';
import { TokenStorageService } from '@service/token-storage.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
  errorText: string = "";
  constructor(
    router: Router,
    tokenService: TokenStorageService,
  ) {
    if (!tokenService.isLogged()) {
      const parsedUrl: URL = new URL(router.url, "http://exis");
      const state: string | null = parsedUrl.searchParams.get("state");
      const sessionState: string | null = parsedUrl.searchParams.get("session_state");
      const code: string | null = parsedUrl.searchParams.get("code");

      if (state && sessionState && code) {
        const s = tokenService.getAuth(state, sessionState, code).subscribe({
          next: (auth: AuthResponse) => {
            s.unsubscribe();

            tokenService.setRefreshToken(auth.refreshToken, Date.now() + 1000 * auth.refreshExpireIn);

            router.navigate(["/"]);
          },
          error: () => {
            s.unsubscribe();

            this.errorText = "Chyba autentizace";
          },
        });
      } else {
        this.errorText = "Chybné parametry";
      }
    }
  }
}
